/* 
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */



if(!window.GS) GS={};
if(!window.GS.Toolbar) GS.Toolbar={};
//if(!window.GS.Toolbar.Tool) GS.Toolbar.Tool={};

GS.Toolbar.Tool=new Class({
    Extends: GS.Toolbar.Tools,
    class_name:'GS.Toolbar.Tool',
    options:{
        'wrapper': null,
        'class':'submenu full',
        'lexico':{'l':'Brightness','c':'Contrast','s':'Saturation'},
        'toolbar':null
    },
    active:1,
    controlled:null,
    initialize:function(conf){
       this.parent(conf);
       //console.warn(conf);
    }
});

GS.Toolbar.Tool.prototype.onDelete=function(){
    //var confirmMsg='Are you sure to delete this frame?';
    var confirmMsg=this.options.lexico.confirms.delete;
    if(this.controlled && this.controlled.requestDelete){

        this.controlled.requestDelete();
        return;
    }
    if(swal){
        swal({
            icon: 'error',
            title: this.options.lexico.confirms.title,
            text: confirmMsg,
            buttons: {
                cancel: this.options.lexico.confirms.cancel_btn,
                delete: {
                    text: this.options.lexico.confirms.confirm_btn,
                    className: "danger",
                    value: true,
                }
            }
        }).then(function(choose){
            if(choose){
                this.dispatch('guide:remove',this.controlled);
                //console.warn('Call delete event');
                if(this.controlled) this.controlled.fireEvent('delete');
                this.dispatch('active:frame', null);
                this.dispatch('user:interaction',1);
            }
        }.bind(this));
    }else{
        if(confirm(confirmMsg) && this.controlled) {
            this.dispatch('guide:remove',this.controlled);
            //console.warn('Call delete event');
            this.controlled.fireEvent('delete');
            this.dispatch('active:frame', null);
            this.dispatch('user:interaction',1);

        }
    }

};

GS.Toolbar.Tool.prototype.configureTools=function(){
    //console.debug('Configure delete....',this.options.type);
    var type=this.options.type,
        w=this.options.wrapper,
        self=this;
    switch(type){
        case 'delete':
            var confirmMsg=this.options.lexico.confirms.delete;
            var onKeyDown=function(e){
                //console.debug('On keydown',self.active,e.key);
                if(self.controlled){
                    if(!self.active) return;
                    if(e.key==="backspace" || e.key==="delete"){
                        if(document.activeElement.tagName !== "INPUT"){
                            e.stop();
                            e.preventDefault();
                            e.stopPropagation();
                            self.onDelete();
                            return false;
                        }
                    }
                }
            };
            w.addEventListener('click',function(e){
                e.preventDefault();
                e.stopPropagation();
                if(!self.active) return;
                self.onDelete();
            });
            
            window.addEvent('keydown',onKeyDown);
            
        break;
         case 'autosyncbackgrounds':
            w.addEvent('click',function(e){
                if(e) e.stop();
                if(!self.active) return;
                self.controlled.fireEvent(type);
                self.dispatch('user:interaction',1);
            });
        break;
        default:
            
        break;
    }
    
};
GS.Toolbar.Tool.prototype.updatePermissions=function(permission){
    var type=this.options.type,
        w=this.options.wrapper,
        self=this;

    //console.debug('BTN Type: %s',type,permission);
    switch(type){
        case 'delete':
            this.active=(permission['delete']);
            w.setStyle('opacity',(this.active) ? 1 : 0.2);
            w.setStyle('display',(this.active) ? 'block' : 'none');
        break;
        case 'autosyncbackgrounds':
            this.active=(permission['autosyncbackgrounds']);
            w.setStyle('display',(this.active) ? 'block' : 'none');
        break;
    }
};
/*GS.Toolbar.Tool.ColorsTools.prototype.menuTMPL=function(){
    var out='    <li class="slider effect-brightness" data-type="effect-brightness" data-uitype="slider"><label>{l}</label></li>';
    out+='      <li class="slider effect-contrast" data-type="effect-contrast" data-uitype="slider"><label>{c}</label></li>';
    out+='      <li class="slider effect-saturation" data-type="effect-saturation" data-uitype="slider"><label>{s}</label></li>';
    return out;
};*/